module.exports = "/images/vendor/flag-icon-css/flags/1x1/cz.svg?80879b0e86919c6859d875da48efd0e0";